import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { ACCOUNT_CREATE_URL } from "../ApiUrls";

export default class AccountCreateRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  url = ACCOUNT_CREATE_URL;

  constructor(accountDetails) {
    super();
    this.body = {
      ...accountDetails,
    };
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => this.url;

  getBody = () => this.body;
}
